export default {
  msal: {
    auth: {
      clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
      authority: process.env.REACT_APP_ENTRA_AUTHORITY,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin + "/Logout"
    },
    loginRequest: {
      scopes: ["openid", "profile"]
    },
    tokenRequest: {
      scopes: [process.env.REACT_APP_ENTRA_API_SCOPE]
    }
  },
  webAppConfiguration: {
    sasalbUrl:
      process.env.NODE_ENV.trim() === "development"
        ? "https://www.amgenlmsjsreports-dev.com/api/sasreport"
        : window.location.origin + "/api/sasreport",
    tasalbUrl:
      process.env.NODE_ENV.trim() === "development"
        ? "https://www.amgenlmsjsreports-dev.com/api/tasreport"
        : window.location.origin + "/api/tasreport"
  }
};
